import {
  SET_FULFILLMENT_OPTIONS,
  RESET_FULFILLMENT_OPTIONS,
  RESET_SHIPPING_ADDRESS
} from 'base/actions/actionTypes';

/*
  this returns the cart values passed to it, except that it will set fulfillment date and time to null if requested fulfillment is set to asap
*/

export const setCartWorkingCopy = options => {
  return {
    type: SET_FULFILLMENT_OPTIONS,
    payload: options
  };
};

export const resetCartWorkingCopy = () => {
  return {
    type: RESET_FULFILLMENT_OPTIONS
  };
};

export const resetCartWorkingCopyDeliveryAddress = () => {
  return {
    type: RESET_SHIPPING_ADDRESS
  };
};

/*
  we only apply cart shipping address data if the online ordering method is delivery
  shipping address fields are used to calculate taxes. for pickup, we set the address to
  the store location, otherwise we can't calculate taxes.
  here, we avoid setting the fulfillment address on the workingCopy cart
  if the cart's starting state is "pickup"
*/
const applyCartShippingData = cart => {
  if (cart.online_ordering_fulfillment_method === 'pickup') {
    return {};
  }

  return {
    shipping_street_address_1: cart.shipping_street_address_1,
    shipping_street_address_2: cart.shipping_street_address_2,
    shipping_city: cart.shipping_city,
    shipping_state: cart.shipping_state,
    shipping_country: cart.shipping_country,
    shipping_postal_code: cart.shipping_postal_code,
    shipping_google_place_id: cart.shipping_google_place_id
  };
};

/*
  we only apply fulfillment date and time if requested fulfillment is asap is true
*/
const applyCartFulfillmentAsapLaterOptions = ({
  requested_fulfillment_is_asap,
  fulfillment_date,
  fulfillment_time
}) => {
  const processed = {
    requested_fulfillment_is_asap,
    fulfillment_date,
    fulfillment_time
  };
  if (requested_fulfillment_is_asap) {
    processed.fulfillment_date = null;
    processed.fulfillment_time = null;
  }
  return processed;
};

export const setWorkingCopyFromCart = () => (dispatch, getState) => {
  const { cart, cartWorkingCopy } = getState();
  dispatch(
    setCartWorkingCopy({
      ...applyCartFulfillmentAsapLaterOptions(cart),
      ...applyCartShippingData(cart),
      // if the user selects delivery or pickup from navbar or cart,
      // we want to preserve that selection instead of resetting
      // what is on the cart
      online_ordering_fulfillment_method:
        cartWorkingCopy.online_ordering_fulfillment_method ||
        cart.online_ordering_fulfillment_method,

      online_ordering_estimated_asap_delivery_range:
        cart.online_ordering_estimated_asap_delivery_range,
      online_ordering_estimated_asap_pickup_time:
        cart.online_ordering_estimated_asap_pickup_time,
      has_online_ordering_delivery_zone: cart.has_online_ordering_delivery_zone,
      online_ordering_location: cart.online_ordering_location,
      is_within_doordash_radius: cart.is_within_doordash_radius,
      total_delivery_time: cart.total_delivery_time
    })
  );
};
